<template>
  <div class="row">
    <div class="col-md-5">
      <span>Sub-categories:</span>
      <div class="custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="(item, idx) in categories" :key="idx">
            <span>{{ item }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-7">
      <span>Vehicle Makes:</span>
      <div class="custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="(item, idx) in makes" :key="idx">
            <span>{{ item.start }} - {{ item.end }}</span>
            <span>{{ item.make }}: {{ item.system }} > {{ item.location }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdasMatrixRecord',
  props: {
    matrix: {
      type: Object,
      default: null
    }
  },
  mounted() {
    if (this.matrix) {
      console.log('Getting Matrix', this.matrix)
    }
  },
  computed: {
    categories() {
      let _data = []
      if (this.matrix) {
        if (this.matrix.items) {
          this.matrix.items.forEach((element) => {
            _data.push(element.item)
          })
        }
      }
      return _data
    },
    makes() {
      let _data = []
      if (this.matrix) {
        if (this.matrix.makes) {
          this.matrix.makes.forEach((element) => {
            _data.push({
              make: element.vehicleMake,
              start: element.yearStart,
              end: element.yearEnd,
              system: element.system,
              location: element.location
            })
          })
        }
      }
      return _data
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  max-height: 120px;
  overflow-x: hidden;
  overflow-y: auto;
}
.custom-list {
  list-style-type: none;
  padding-inline-start: 10px;
  li {
    padding: 5px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-right: 8px;
  }
}
</style>
